export default __webpack_public_path__ + "static/media/klima.b62c05cd.jpg";